"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { usePathname } from "next/navigation";
import { Trophy, Target, Users, Gift } from "lucide-react";
import { Modal } from "@/components/ui/modals/Modal";
import { Surface } from "@/components/ui/Surface";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
interface SignInPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
}
const BENEFIT_ICONS = [Target, Users, Trophy, Gift];
export const SignInPromptModal: React.FC<SignInPromptModalProps> = t0 => {
  const $ = _c(35);
  const {
    isOpen,
    onClose
  } = t0;
  const labels = useLabels();
  const nav = useNavigation();
  const pathname = usePathname();
  const t = labels.signInPrompt;
  const returnUrl = encodeURIComponent(pathname || "/");
  let t1;
  if ($[0] !== t.benefit1 || $[1] !== t.benefit2 || $[2] !== t.benefit3) {
    t1 = [t.benefit1, t.benefit2, t.benefit3];
    $[0] = t.benefit1;
    $[1] = t.benefit2;
    $[2] = t.benefit3;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const benefits = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="inline-flex items-center justify-center w-16 h-16 bg-current/10 rounded-full mb-4"><Trophy className="w-8 h-8" /></div>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t.title) {
    t3 = <h2 className="text-2xl font-bold">{t.title}</h2>;
    $[5] = t.title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t.description) {
    t4 = <p className="mt-2 text-sm leading-relaxed opacity-85">{t.description}</p>;
    $[7] = t.description;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="px-6 pt-8 pb-6 text-center">{t2}{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== benefits) {
    t6 = <div className="px-6 py-6 space-y-4">{benefits.map(_temp)}</div>;
    $[12] = benefits;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== nav) {
    t7 = nav.signUp();
    $[14] = nav;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = `${t7}?returnUrl=${returnUrl}`;
  let t9;
  if ($[16] !== t.signUpButton || $[17] !== t8) {
    t9 = <a href={t8} className="btn-primary block w-full text-center py-3 px-4 font-semibold text-sm">{t.signUpButton}</a>;
    $[16] = t.signUpButton;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== nav) {
    t10 = nav.signIn();
    $[19] = nav;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const t11 = `${t10}?returnUrl=${returnUrl}`;
  let t12;
  if ($[21] !== t.signInButton || $[22] !== t11) {
    t12 = <a href={t11} className="btn-plain block w-full text-center py-3 px-4 font-medium text-sm">{t.signInButton}</a>;
    $[21] = t.signInButton;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t9) {
    t13 = <div className="px-6 pb-6 space-y-3">{t9}{t12}</div>;
    $[24] = t12;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t5 || $[29] !== t6) {
    t14 = <Surface slot="modal" className="w-[90vw] max-w-md overflow-hidden">{t5}{t6}{t13}</Surface>;
    $[27] = t13;
    $[28] = t5;
    $[29] = t6;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== isOpen || $[32] !== onClose || $[33] !== t14) {
    t15 = <Modal isOpen={isOpen} onClose={onClose}>{t14}</Modal>;
    $[31] = isOpen;
    $[32] = onClose;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
};
function _temp(benefit, index) {
  const Icon = BENEFIT_ICONS[index];
  return <div key={index} className="flex items-start gap-3"><div className="shrink-0 w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center mt-0.5"><Icon className="w-4 h-4 text-primary" /></div><span className="text-sm opacity-80 leading-relaxed pt-1">{benefit}</span></div>;
}